import { Button } from "@components/atoms/Button"
import { ScrollReveal } from "@components/motion/Transitioned"
import { cn } from "@utils/tw"
import { defineBlock, EditableText, InnerBlocks } from "eddev/blocks"
import { useState } from "react"
import { motion } from "motion/react"

export const meta: BlockMeta = {
  title: "Expandable",
  icon: "block-default",
  tags: ["#page"],
}

export default defineBlock("content/expandable", (props) => {
  const [expanded, setExpanded] = useState(false)
  const open = expanded || env.admin

  return (
    <ScrollReveal>
      <div className={cn("max-w-grid mx-auto w-full flex flex-col gap-6 mt-7")}>
        <Button onClick={() => setExpanded((prev) => !prev)} data-transition="fade">
          <EditableText as="span" store="title" className="type-label-l" placeholder="Enter expandable button text" />
        </Button>
        <div className="w-full flex flex-col" data-transition="children/scale">
          <motion.div
            className={cn("w-full", !open && "overflow-hidden")}
            animate={{ height: open ? "auto" : 0, opacity: open ? 1 : 0 }}
          >
            <div className="[&_h2]:!mt-0 [&_h2]:!pt-3 [&_h2]:!mb-5 [&_p]:!mt-0 [&_p]:!mb-5 [&_p.is-style-heading]:!mb-9 [&_li]:!type-body-xl [&_li]:!my-0 [&_ul]:!mb-5 [&_ol]:!mb-5 [&_a]:!underline">
              <InnerBlocks
                allowedBlocks={["#inline"]}
                adminClassName="flex flex-col gap-4"
                defaultBlocks={[
                  [
                    "core/paragraph",
                    { placeholder: "Enter your expanded content here...", className: "is-style-heading" },
                  ],
                ]}
                orientation="vertical"
              />
            </div>
          </motion.div>
        </div>
      </div>
    </ScrollReveal>
  )
})
